export class Polygon {
  id?: number;

  title: string;

  tourId?: number;

  scaleX: number;

  scaleY: number;

  scaleZ: number;

  positionX: number;

  positionY: number;

  positionZ: number;

  rotationX: number;

  rotationY: number;

  rotationZ: number;

  uuid?: string | null;

  active: boolean;

  colorDefault: string;

  colorHover: string;

  colorClick: string;

  opacityDefault: number;

  opacityHover: number;

  opacityClick: number;

  edgesOpacityDefault: number;

  edgesOpacityHover: number;

  edgesOpacityClick: number;

  sweep_uuid: string | null;

  srX: number;

  srY: number;

  srZ: number;

  floor: number;

  polygonsActions: Array<PolygonAction>;

  products: number[];

  constructor(model: any = {}) {
    this.id = model.id;
    this.title = model.title || '';
    this.tourId = model.tourId;
    this.scaleX = model.scaleX || 1;
    this.scaleY = model.scaleY || 1;
    this.scaleZ = model.scaleZ || 1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.active = typeof model.active === 'boolean' ? model.active : true;
    this.uuid = model.uuid || null;

    this.colorDefault = model.colorDefault || '#ea475c';
    this.colorHover = model.colorHover || '#FFFFFF';
    this.colorClick = model.colorClick || '#ea475c';
    this.opacityDefault = model.opacityDefault >= 0 ? model.opacityDefault : 0.2;
    this.opacityHover = model.opacityHover >= 0 ? model.opacityHover : 0.4;
    this.opacityClick = model.opacityClick >= 0 ? model.opacityClick : 0.5;
    this.edgesOpacityDefault = model.edgesOpacityDefault >= 0 ? model.edgesOpacityDefault : 0.5;
    this.edgesOpacityHover = model.edgesOpacityHover >= 0 ? model.edgesOpacityHover : 0.7;
    this.edgesOpacityClick = model.edgesOpacityClick >= 0 ? model.edgesOpacityClick : 0.8;
    this.sweep_uuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.floor = model.floor || 0;
    this.products =
      model.products?.length > 0 ? model.products.map((item: { id: number }) => item.id) : [];
    this.polygonsActions = model.polygonsActions || [];
  }

  public getURL(): string {
    return '';
  }
}

export enum PolygonActionType {
  None = 'none',
  Text = 'text',
  Image = 'image',
  Music = 'music',
  Video = 'video',
  Iframe = 'iframe',
  Tab = 'tab',
  Panorama = 'panorama',
  Menu = 'menu',
  Treedis = 'treedis',
  Product = 'product',
}

export enum PolygonActionAction {
  Click = 'click',
  Hover = 'hover',
}

export enum PolygonActionRes {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export enum PolygonActionMode {
  Ecommerce = 'ecommerce',
  Game = 'game',
  VS = 'vs',
}

export class PolygonAction {
  id?: number;

  polygonId?: number | null;

  mode: PolygonActionMode;

  type: PolygonActionType;

  action: PolygonActionAction;

  url: string;

  text: string;

  resolution: PolygonActionRes;

  width: number;

  height: number;

  panoramaId: number | null;

  menuId: number | null;

  subMenuId: number | null;

  subSubMenuId: number | null;

  gameBackpack: boolean;

  fullscreen: boolean;

  autoPlay: boolean;

  constructor(model: any = {}) {
    this.id = model.id;
    this.polygonId = model.polygonId || null;
    this.mode = model.actionMode || PolygonActionMode.VS;
    this.type = model.type || PolygonActionType.None;
    this.action = model.action || PolygonActionAction.Click;
    this.url = model.url || '';
    this.text = model.text || '';
    this.resolution = model.resolution || PolygonActionRes.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 80;
    this.panoramaId = model.panoramaId || null;
    this.menuId = model.menuId || null;
    this.subMenuId = model.subMenuId || null;
    this.subSubMenuId = model.subSubMenuId || null;
    this.gameBackpack = model.gameBackpack || false;
    this.fullscreen = model.fullscreen || false;
    this.autoPlay = model.autoPlay || false;
  }
}
